<template>
  <div id="app">
    <NavBar :key="isAuthenticated + $route.fullPath" />
    <router-view :key="$route.fullPath" />
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";

//La interfaz de la aplicación está formada por una barra de navegación, la vista de cada página y un pie de página.
export default {
  name: "app",
  components: {
    NavBar,
    Footer
  },
  computed: {
    appTitle() {
      return this.$store.state.appTitle;
    },
    // @vuese
    // Devuelve si está autenticado el usuario
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
